import 'jquery';
import lozad from 'lozad';
export default {
    init() {

        const observer = lozad(); // lazy loads elements with default selector as '.lozad'
        observer.observe();



        // JavaScript to be fired on all pages
        // eslint-disable-next-line no-undef
        var ajax_url = ajax_object.ajax_url;
        var step = 0;
        var progressPercentage = `${20 * step}%`;
        var applicationDetails = {
            first_name: '',
            last_name: '',
            gender: '',
            email: '',
            address_1: '',
            info_city: '',
            phone_1: '',
            'institute_name[]': [],
            'qualification_type[]': [],
            'study[]': [],
            'education_city[]': [],
            'start_date[]': [],
            'edu_actual_date[]': [],
            'currently_study[]': [false],
            'job_title[]': [],
            'company_name[]': [],
            'employment_type[]': [],
            'job_city[]': [],
            'job_start_date[]': [],
            'job_actual_date[]': [],
            'currently_working[]': [false],
            resume: null,
        }
        if ($('.template-contact-us').length > 0) {
            $('#contact-form').on('submit', function (e) {
                e.preventDefault();
                $('#error').hide();
                $('#success').hide();
                $('#contact-form').find('button').attr('disabled', true);
                $('#contact-form').find('button').html('Submiting');
                var formData = new FormData($('#contact-form')[0]);
                formData.append('action', 'contactUsCallback');
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        // eslint-disable-next-line no-undef
                        //   grecaptcha.reset();
                        var data = JSON.parse(this.responseText);
                        if (data.status == 1 || data.status == '1') {
                            $('#success').html(data.message);
                            $('#success').show();
                            $('#contact-form')[0].reset();

                        } else {
                            $('html, body').animate({
                                scrollTop: $('#contact-form').offset().top,
                            }, 2000);
                            $('#error').html(data.html);
                            $('#error').show();
                        }

                        $('#contact-form').find('button').removeClass('loading');
                        $('#contact-form').find('button').removeAttr('disabled');
                        $('#contact-form').find('button').html('Send');
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            });
        }

        if ($('#jobSearch').length > 0) {
            $('#jobSearch').on('submit', function (e) {
                e.preventDefault();
                $('.search-button').removeClass('loading');
                $('.search-button').removeAttr('disabled');
                var formData = new FormData($('#jobSearch')[0]);
                formData.append('action', 'jobSearch');
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        // eslint-disable-next-line no-undef
                        //   grecaptcha.reset();
                        var data = JSON.parse(this.responseText);
                        if (data.status == 1) {
                            $('.career-listing .container .row').html(data.html);
                        }
                        $('.search-button').removeClass('loading');
                        $('.search-button').removeAttr('disabled');
                        $('.clear-search').addClass('show-clear');
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            });
        }

        if ($('#jobSearch').length > 0) {
            $('.clear-search').on('click', function () {
                $('#jobSearch')[0].reset();
                var formData = new FormData($('#jobSearch')[0]);
                formData.append('action', 'jobSearch');
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        var data = JSON.parse(this.responseText);
                        if (data.status == 1) {
                            $('.career-listing .container .row').html(data.html);
                            $('.clear-search').removeClass('show-clear');
                        }
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            })
        }


        if ($('.template-application').length > 0) {
            $('#ApplyJob').on('submit', function (e) {
                e.preventDefault();
                $('.warning').addClass('warning');
                $('#error').hide();
                $('#success').hide();
                $('#ApplyJob').find('button').attr('disabled', true);
                $('#ApplyJob').find(':submit').html('Submitting');
                var formData = new FormData($('#ApplyJob')[0]);
                formData.append('action', 'applyNow');
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        // eslint-disable-next-line no-undef
                        //   grecaptcha.reset();
                        var data = JSON.parse(this.responseText);
                        if (data.status == 1 || data.status == '1') {
                            $(window).scrollTop(104);
                            $('#ApplyJob')[0].reset();
                            $('.drop-box :input').val(null);
                            $('.file-detail-box').removeClass('has-file');
                            $('.file-detail-box p').text('');
                            $('#ApplyJob').find(':submit').attr('disabled', true);
                            applicationDetails = { ...applicationDetails, resume: null };
                            step = step + 1;
                            progressPercentage = (step * 20) + '%';
                            $('.progress-bar').css('width', progressPercentage);
                            setTimeout(() => {
                                $('#exampleModal').modal({
                                    show: true,
                                })
                                $('body').css({ 'overflow': 'hidden', 'height': '100vh' })
                            }, 700);
                        } else {
                            if ($.isPlainObject(data.errors) && Object.keys(data.errors).length > 0) {
                                var i = 0;
                                $.each(data.errors, function (index, value) {
                                    console.log(value);
                                    if (i == 0) {
                                        $('.application-form').removeClass('show-form');
                                        $('[name="' + index + '"]').closest('.application-form').addClass('show-form');
                                        var step = $('[name="' + index + '"]').closest('.application-form').data('step');
                                        $('[name="' + index + '"]').addClass('warning');
                                        $('.step-root').each(function (i, item) {
                                            var activeStepMenu = $(item).data('step');
                                            if (parseInt(step) < parseInt(activeStepMenu)) {
                                                $(item).removeClass('step-root-active');
                                            }
                                        });
                                    }
                                    i++;
                                });
                            }

                            $('html, body').animate({
                                scrollTop: $('#ApplyJob').offset().top,
                            }, 2000);
                            $('#error').html(data.html);
                            $('#error').show();
                        }

                        $('#ApplyJob').find(':submit').removeClass('loading');
                        $('#ApplyJob').find('button').removeAttr('disabled');
                        $('#ApplyJob').find(':submit').html('Send');
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            });
        }

        function spliceArray(array, index) {
            let newArray = [...array];
            newArray.splice(index, 1);
            return newArray;
        }

        function ValidateEmail(mail) {
            if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)) return true;
            return false;
        }

        function validatePhone(phone) {
            if (/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm.test(phone)) return true;
            return false;
        }

        function ifChecked() {
            $('#education-details-container').find('input[type="checkbox"]').each(function (index, item) {
                if ($(item).is(':checked')) {
                    $('input[name="edu_actual_date[]"]').each(function (index_2, input) {
                        if (index === index_2) {
                            $(input).val(new Date().toISOString().split('T')[0]);
                        }
                    })

                }
            });

        }

        function ifJobChecked() {
            $('#experience-details-container').find('input[type="checkbox"]').each(function (index, item) {
                if ($(item).is(':checked')) {
                    $('input[name="job_actual_date[]"]').each(function (index_2, input) {
                        if (index === index_2) {
                            $(input).val(new Date().toISOString().split('T')[0]);
                        }
                    })
                }
            });
        }

        $(function () {
            // Function for next form step
            $.fn.nextStep = function (stepperClass, currentForm, nextForm) {
                $(window).scrollTop(104);
                $(stepperClass).addClass('step-root-active');
                $(currentForm).removeClass('show-form');
                $(nextForm).addClass('show-form');
                step = step + 1;
                progressPercentage = (step * 20) + '%';
                $('.progress-bar').css('width', progressPercentage);
            }
            // Function for going back
            $.fn.backStep = function (stepperClass, currentForm, prevForm) {
                $(window).scrollTop(104);
                $(stepperClass).removeClass('step-root-active');
                $(currentForm).removeClass('show-form');
                $(prevForm).addClass('show-form');
                step = step - 1;
                progressPercentage = (step * 20) + '%';
                $('.progress-bar').css('width', progressPercentage);
            }
            // Function for displaying file name
            $.fn.showFile = function (fileName) {
                if (applicationDetails.resume !== null) {
                    $('.file-detail-box').addClass('has-file');
                    $('.file-detail-box p').text(fileName);
                }
            }
            $.fn.deleteFile = function () {
                $('.drop-box :input').val(null);
                $('.file-detail-box').removeClass('has-file');
                $('.file-detail-box p').text('');
            }

            $.fn.showFileError = function (error) {
                $('#file-error').addClass('show-error');
                $('#file-error').text(error);
            }
            $.fn.checkFile = function (filename) {
                var ext = filename.split('.').pop().toLowerCase();
                if ($.inArray(ext, ['pdf', 'doc', 'docx', 'txt']) == -1) {
                    return false;
                }
                return true;
            }

            $.fn.review = function () {
                $('.review-box').each(function (index, item) {
                    if (index === 0) {
                        $(item).find('.information-wrap').each(function (index, item) {
                            console.log(index);
                            $(item).find('.info').each(function (index, item) {
                                console.log(index);
                                $(item).text(applicationDetails[$(item).data('info')]);
                            });
                        })
                    }
                    if (index === 1) {
                        let prevLength = $('.education-review').length;
                        let length = applicationDetails['institute_name[]'].length;
                        for (let i = prevLength; i < length; i++) {
                            $('.education-review').last().after($('.education-review').first().clone());
                        }
                        $('.education-review').each(function (index, item) {
                            console.log(index);
                            $(item).find('.information-wrap').each(function (index_2, wrap) {
                                console.log(index_2);
                                $(wrap).find('.info').each(function (index_3, info) {
                                    console.log(index_3);
                                    $(info).text(applicationDetails[$(info).data('info')][index])
                                })
                            })
                        })
                    }
                    if (index === 2) {
                        let prevLength = $('.experience-review').length;
                        let length = applicationDetails['job_title[]'].length;
                        for (let i = prevLength; i < length; i++) {
                            $('.experience-review').last().after($('.experience-review').first().clone());
                        }
                        $('.experience-review').each(function (index, item) {
                            console.log(index);
                            $(item).find('.information-wrap').each(function (index_2, wrap) {
                                console.log(index_2);
                                $(wrap).find('.info').each(function (index_3, info) {
                                    console.log(index_3);
                                    $(info).text(applicationDetails[$(info).data('info')][index])
                                })
                            })
                        })
                    }
                    if (index === 3) {
                        $(item).find('.information-wrap').each(function (index, item) {
                            console.log(index);
                            $(item).find('[data-info="file-name"]').text(applicationDetails.resume.name);
                            // var size = applicationDetails.resume.size;
                            // var sizeDisplay;
                            // if (size > 1024 && size < 1048576) {
                            //     sizeDisplay = `${(size / 1024).toFixed(2)} KB`;
                            // }
                            // else if (size >= 1048576) {
                            //     sizeDisplay = `${(size / (1024 * 1024)).toFixed(2)} MB`;
                            // }
                            // else {
                            //     sizeDisplay = `${size} B`
                            // }
                            // $(item).find('[data-info="file-size"]').text(sizeDisplay);
                        })
                    }
                })
                console.log('Application details -> ', applicationDetails);
            }
            $.fn.isComplete = function (element) {
                var error = 0;
                $(element).closest('.application-form').find(':input').each(function (index, item) {
                    console.log(index);
                    var name = $(item).attr('name');
                    $(`[name="${name}"]`).each(function (index_2, input) {
                        console.log(index_2);
                        if ($(input).prop('required')) {
                            if ($(input).val() === '') {
                                error++;
                            }
                        }
                    })
                });
                if (error > 0) return false;
                return true;
            }

            $.fn.setValue = function (element) {
                var newApplicationDetails = { ...applicationDetails };
                $(element).closest('.application-form').find(':input').each(function (index, item) {
                    console.log(index);
                    if (Array.isArray(newApplicationDetails[$(item).attr('name')])) {
                        var name = $(item).attr('name');
                        $(`[name="${name}"]`).each(function (index_2, input) {
                            console.log(index_2);
                            if ($(input).attr('type') === 'checkbox') {
                                if ($(input).is(':checked')) {
                                    newApplicationDetails[$(item).attr('name')][index_2] = 'Yes';
                                }
                                else {
                                    newApplicationDetails[$(item).attr('name')][index_2] = 'No';
                                }
                            } else {
                                newApplicationDetails[$(item).attr('name')][index_2] = $(input).val();
                            }
                        })
                    }
                    else {
                        newApplicationDetails[$(item).attr('name')] = $(item).val();
                    }
                })
                applicationDetails = newApplicationDetails;
            }
            // // Submitting step 1 form
            $('#step-1 .next-btn').click(function () {
                $('#step-1 .input-box').removeClass('show-error');
                if ($.fn.isComplete(this)) {
                    if (ValidateEmail($('.input-box input[type="email"]').val()) && validatePhone($('.input-box input[name="phone_1"]').val())) {
                        $.fn.setValue(this);
                        $.fn.nextStep('#stepper-2', '#step-1', '#step-2')
                    }

                    else {
                        if (!validatePhone($('.input-box input[name="phone_1"]').val())) {
                            $('.input-box input[name="phone_1"]').closest('.input-box').addClass('show-error');
                        }
                        else {
                            $('.input-box input[type="email"]').closest('.input-box').addClass('show-error');
                        }
                    }

                } else {
                    $('#step-1 .input-box').each(function (index, item) {
                        var inputVal = $(item).find(':input').val();
                        if (inputVal === '') {
                            if ($(item).find(':input').prop('required'))
                                $(item).addClass('show-error');
                        }
                    })
                    if (!validatePhone($('.input-box input[name="phone_1"]').val())) {
                        $('.input-box input[name="phone_1"]').closest('.input-box').addClass('show-error');
                    }
                    if (!ValidateEmail($('.input-box input[type="email"]').val())) {
                        $('.input-box input[type="email"]').closest('.input-box').addClass('show-error');
                    }
                }
            })
            // // Submitting step 2 form
            $('#step-2 .next-btn').click(function () {
                $('#step-2 .input-box').removeClass('show-error');
                ifChecked();
                if ($.fn.isComplete(this)) {
                    $.fn.setValue(this);
                    $.fn.nextStep('#stepper-3', '#step-2', '#step-3')
                } else {
                    $('#step-2 .input-box').each(function (index, item) {
                        var inputVal = $(item).find(':input').val();
                        if (inputVal === '') {
                            if ($(item).find(':input').prop('required'))
                                $(item).addClass('show-error');
                        }
                    })
                }
            })
            // // Submitting step 3 form
            $('#step-3 .next-btn').click(function () {
                $('#step-3 .input-box').removeClass('show-error');
                ifJobChecked();
                if ($.fn.isComplete(this)) {
                    $.fn.setValue(this);
                    $.fn.nextStep('#stepper-4', '#step-3', '#step-4')
                } else {
                    $('#step-3 .input-box').each(function (index, item) {
                        var inputVal = $(item).find(':input').val();
                        if (inputVal === '') {
                            if ($(item).find(':input').prop('required'))
                                $(item).addClass('show-error');
                        }
                    })
                }
            })
            // Submitting step 4 form
            $('#step-4 .next-btn').click(function () {
                $('#step-4 .input-box').removeClass('show-error');
                if (applicationDetails['resume'] !== null) {
                    $.fn.nextStep('#stepper-5', '#step-4', '#step-5')
                    $.fn.review();
                } else {
                    $.fn.showFileError('Please upload your resume');
                }
            })
            // Going back to step 1 form
            $('#step-2 .inverted-button').click(function () {
                $.fn.backStep('#stepper-2', '#step-2', '#step-1')
            })
            // Going back to step 2 form
            $('#step-3 .inverted-button').click(function () {
                $.fn.backStep('#stepper-3', '#step-3', '#step-2')
            })
            // Going back to step 3 form
            $('#step-4 .inverted-button').click(function () {
                $.fn.backStep('#stepper-4', '#step-4', '#step-3')
            })
            // Going back to step 4 form
            $('#step-5 .inverted-button').click(function () {
                $.fn.backStep('#stepper-5', '#step-5', '#step-4');
                $('.education-review').each(function (index, item) {
                    if (index !== 0) {
                        $(item).remove();
                    }
                })
                $('.experience-review').each(function (index, item) {
                    if (index !== 0) {
                        $(item).remove();
                    }
                })
            })

            $('#education-details-container').on('focus', '.date-box input', function () {
                $(this).attr('type', 'date');
                $('.date-box .end-adornment').css('display', 'none')
            })

            $('#experience-details-container').on('focus', '.date-box input', function () {
                $(this).attr('type', 'date');
                $('.date-box .end-adornment').css('display', 'none')
            })

            $('#education-details-container').on('blur', '.date-box input', function () {
                $(this).attr('type', 'text');
                $('.date-box .end-adornment').css('display', 'block')
            })

            $('#experience-details-container').on('blur', '.date-box input', function () {
                $(this).attr('type', 'text');
                $('.date-box .end-adornment').css('display', 'block')
            })

            $('#add-education').click(function () {
                $('.education-rows').last().after($('.education-rows').first().clone());
                $('.education-rows').last().find(':input').each(function (index, item) {
                    console.log(index);
                    $(item).val('');
                    $(item).prop('checked', false);
                    $(item).closest('.input-box').removeClass('show-error');
                })
            })

            $('#add-experience').click(function () {
                $('.experience-rows').last().after($('.experience-rows').first().clone());
                $('.experience-rows').last().find(':input').each(function (index, item) {
                    console.log(index);
                    $(item).val('');
                    $(item).prop('checked', false);
                    $(item).closest('.input-box').removeClass('show-error');
                })
            })

            $('.toggle-btn').click(function () {
                if ($('.toggle-btn').hasClass('toggle-btn-open')) {
                    $('.mobile-menu').removeClass('mobile-menu-open');
                    $('body').css('height', 'auto');
                    $('header').removeClass('invert-header');
                    $(this).removeClass('toggle-btn-open');
                    $('.sub-menu').removeClass('sub-menu-open');
                    $('.sub-menu').removeClass('about');
                    $('.sub-menu').removeClass('automotive');
                }
                else {
                    $('.mobile-menu').addClass('mobile-menu-open');
                    $('body').css('height', '100vh');
                    $('header').addClass('invert-header');
                    $(this).addClass('toggle-btn-open');
                }
            })
            $('.menu-item-has-children').click(function () {
                var no_of_el = $(this).find('.sub-menu li').length;
                if (no_of_el === 3) {
                    $(this).find('.sub-menu').toggleClass('sub-menu-open about')
                }
                else {
                    $(this).find('.sub-menu').toggleClass('sub-menu-open automotive')
                }
            })
            $('#step-4 .drop-box :input').change(function (e) {
                $('#file-error').removeClass('show-error');
                var newApplicationDetails = { ...applicationDetails };
                const file = e.target.files[0];
                if (file) {
                    if ($.fn.checkFile(file.name)) {
                        if (file.size < 5242880) {
                            newApplicationDetails['resume'] = file;
                            applicationDetails = newApplicationDetails;
                            $.fn.showFile(file.name);
                        }
                        else {
                            $.fn.showFileError('File size is too large!');
                        }
                    }
                    else {
                        $.fn.showFileError('Invalid file type');
                    }
                }
            })
            $('#file-delete-btn').click(function () {
                var newApplicationDetails = { ...applicationDetails };
                newApplicationDetails['resume'] = null;
                applicationDetails = newApplicationDetails;
                $.fn.deleteFile();
                $('#file-error').removeClass('show-error');
                $('#file-error').text('');
            })
            var education_length = $('.education-rows').length;
            for (let e = 0; e < education_length; e++) {
                $('#education-details-container').on('click', '.delete-icon button', function () {
                    $(this).parents('.education-rows').remove();
                    applicationDetails = {
                        ...applicationDetails,
                        'institute_name[]': spliceArray(applicationDetails['institute_name[]'], e),
                        'qualification_type[]': spliceArray(applicationDetails['qualification_type[]'], e),
                        'study[]': spliceArray(applicationDetails['study[]'], e),
                        'education_city[]': spliceArray(applicationDetails['education_city[]'], e),
                        'start_date[]': spliceArray(applicationDetails['start_date[]'], e),
                        'edu_actual_date[]': spliceArray(applicationDetails['edu_actual_date[]'], e),
                        'currently_study[]': spliceArray(applicationDetails['currently_study[]'], e),
                    }
                })
            }
            var experience_length = $('.experience-rows').length;
            for (let e = 0; e < experience_length; e++) {
                $('#experience-details-container').on('click', '.delete-icon button', function () {
                    $(this).parents('.experience-rows').remove();
                    applicationDetails = {
                        ...applicationDetails,
                        'job_title[]': spliceArray(applicationDetails['job_title[]'], e),
                        'company_name[]': spliceArray(applicationDetails['company_name[]'], e),
                        'employment_type[]': spliceArray(applicationDetails['employment_type[]'], e),
                        'job_city[]': spliceArray(applicationDetails['job_city[]'], e),
                        'job_start_date[]': spliceArray(applicationDetails['job_start_date[]'], e),
                        'job_actual_date[]': spliceArray(applicationDetails['job_actual_date[]'], e),
                        'currently_working[]': spliceArray(applicationDetails['currently_working[]'], e),
                    }
                })
            }
            for (let c = 0; c < education_length; c++) {
                $('#education-details-container').on('change', 'input[type="checkbox"]', function () {
                    $('#education-detatils-container input[name="edu_actual_date[]"]').each(function (index, input) {
                        if (c === index) {
                            if ($(this).is(':checked')) {
                                $(input).removeAttr('required');
                            }
                            else {
                                $(input).attr('required', 'true');
                            }
                        }
                    })
                })
            }

            $('#exampleModal').on('hide.bs.modal', function () {
                window.location.href = '/careers';
            })
        })
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

    },

};








// WEBPACK FOOTER //
// ./scripts/routes/common.js